export enum ContractingPhaseENUM {
  QUOTATION = "QUOTATION",
  ON_APPROVAL = "ON_APPROVAL",
  CONTRACTING = "CONTRACTING",
  FINISHED = "FINISHED",
  ON_APPROVAL_RECEIPT = "ON_APPROVAL_RECEIPT",
  TOTALLY_COMPLETED = "TOTALLY_COMPLETED",
}
